import { api } from '@/lib/api';

/** Saves an authenticated file response (e.g. a CSV export) under `filename`. */
export async function downloadFile(path: string, filename: string) {
  const blob = (await api.get<Blob>(path, { responseType: 'blob' })).data;
  saveBlob(blob, filename);
}

/** Saves a file the browser already holds (e.g. a CSV returned by a POST). */
export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
